import React from "react";
import Header from "@/components/landing/Header";
import FeelingArrivesSection from "@/components/landing/FeelingArrivesSection";
import LifeSpeaksSection from "@/components/landing/LifeSpeaksSection";
import NewPerspectiveSection from "@/components/landing/NewPerspectiveSection";
import BehindStoriesSection from "@/components/landing/BehindStoriesSection";
import SituationChangesSection from "@/components/landing/SituationChangesSection";
import NextPageCTA from "@/components/landing/NextPageCTA";
import PageFooter from "@/components/landing/PageFooter";
import RelatedPages from "@/components/landing/RelatedPages";
import { ABOUT_PAGES } from "@/data/navigation";

export default function Feeling() {
  return (
    <main className="bg-warm text-graphite min-h-screen">
      <Header />
      {/* Top padding to clear the fixed header on a content page */}
      <div className="pt-24 md:pt-28" />
      <FeelingArrivesSection />
      <LifeSpeaksSection />
      <NewPerspectiveSection />
      <BehindStoriesSection />
      <SituationChangesSection />
      <NextPageCTA testId="next-page-cta-feeling" />
      <RelatedPages
        pages={ABOUT_PAGES.filter((p) => p.to !== "/egy-erzes")}
        testId="related-pages-feeling"
      />
      <PageFooter />
    </main>
  );
}
